import cleanUpResponse from '@/util/cleanUpResponse';

export default async function SubmitCustomerCommunication(formData) {
  const response = await $.soap({
    body: {
      SubmitCustomerCommunication: {
        $xmlns: 'http://dla.mil/ems/bpm/common/memo',
        CustomerID: formData.objectId,
        Memo: formData.memo
      }
    }
  });

  cleanUpResponse(response);
  return response;
}
